import React, {useEffect, useState} from "react";
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  TextField, Button, Snackbar,
  Grid
} from '@material-ui/core';
import { Card } from "react-bootstrap";
import { CardBody } from "../../../_metronic/_partials/controls";

import { getUser } from '../../../index';

import Editor from "../../components/Editor";

import api from '../../services/api';

import AlertHelper from '../../components/Alert';
import _, { range } from 'lodash';

export default function Template(props) {
  const newStep = {
    objects: [],
    content: "[]",
    stepTypeId: 2,
    name: '',
    duration: "0",
    numero: 1,
    instruction: ''
}  
  const std = {
    name: '',
    classification: '',
    pilar: '',
    transfer: '',
    applicableToNewColleague: '',
    StructureId: null,
    standardType: "Template",
    userId: getUser().id,
    status: 1,
    version: 1,
    steps: [newStep],
    epis: [],
    tools: [],
    lpps: [],
    images: []
  }

  const initStateErrors = {
      hasError: false,
      Name: "",
      Structure: "",
      station: "",
      productActivity: "",
      alertProcedure: ""
  };
  
  const [snackBar, setSnackBar] = useState({
    isOpen: false,
    message: '',
    vertical: 'top',
    horizontal: 'right',
    type: 'error'
  });

  const [errors, setErrors] = useState(initStateErrors);
  const [standard, setStandard] = useState(std);
  const [idx, setIdx] = useState(0);

  const handleCloseSnackbar = () => {
    setSnackBar({ ...snackBar, isOpen: false, message: '' })
  }

  function saveData(for_approval = false, bypassApprovalFlow = false) {

    //setIsSaving(true);

    //cria content (string) dos objetos de cada step
    var newSteps = standard.steps.map((step, idx) => {
        step.numero = idx + 1;
        if (step.objects) {
            step.content = JSON.stringify(step.objects)
        }
        return step
    })

    const newTemplates = newSteps.map(({
      name: standardClassification,
      ...rest
    }) => ({
      standardClassification, ...rest
    }))

    return api
      .put('/template', newTemplates[idx])
      .then(response => {
        setSnackBar({ ...snackBar, isOpen: true, message: 'Template Salvo', type: 'success' })
        console.log("Templates Salvos");
      })
      .catch(error => {
        setSnackBar({ ...snackBar, isOpen: true, message: 'Template Não Salvo', type: 'error' })
        console.log(error);
    });

  }

  function handleChange(newStd) {
    setStandard(newStd);
  }

  function handleSelectStandard(step) {
    setStandard({...standard, standardType:step.standardType})
    setIdx(step.id - 1)
  }

  function getTemplates() {
    //setLoad(true)
    return api
        .get('/template')
        .then(response => {
            console.log(response.data);
            //var templates = response.data;

           //templates = _.orderBy(templates, ['standardClassification'], ['asc'])
            const steps = response.data.map(({
              standardClassification: name,
              ...rest
            }) => ({
              name, ...rest
            }))
            setStandard({...standard, steps:steps});
        })
        .catch(error => {
            console.log("Erro na localização dos Templates");
        });
  }

    useEffect(() => { 
      getTemplates();
    },[])

    return (
      <>
      <div style={{position: 'relative'}}>
        <div className='d-flex flex-column'>
          <div className='mt-2 row'>
            <div className='col-8'>
                  <div key={'combo0'} className='mx-2 my-2 flex-grow-2'>
                      <p className='m-0'>Template</p>
                      <Autocomplete
                          id="combo-box-demo"
                          
                          options={standard.steps}
                          value={ standard.steps[idx] }
                          getOptionLabel={(option) => option.name}
                          style={{ width: '100%' }}
                          className={`form-control ${errors.hasError && errors.Structure ? 'is-invalid' : ''}`}
                          onChange={(event, newValue) => {
                              handleSelectStandard(newValue);
                          }}
                          renderInput={(params) => <TextField {...params} label="" />}
                      />
                      {
                          errors.hasError && errors.Structure
                              ? <div class="invalid-feedback">
                                  {errors.Structure}
                              </div>
                              : ""
                      }
                  </div>
            </div>
            <div className=' col-3 mt-3'>
              <div className='mx-2 mt-5 flex-grow-2'>
                <Button id="Salvar" variant="contained" color="primary" className='' onClick={() => {
                  saveData()
                }}>Salvar</Button>
              <Snackbar
                open={snackBar.isOpen}
                anchorOrigin={{ vertical: snackBar.vertical, horizontal: snackBar.horizontal }}
                key={snackBar.vertical + snackBar.horizontal}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
              >
              <AlertHelper onClose={handleCloseSnackbar} severity={snackBar.type}>
                  {snackBar.message}
              </AlertHelper>
              </Snackbar>    
              </div>
            </div>            
          </div>
        </div>
      </div>
      <div>
        <Card>
          <CardBody>
            <Grid container justify="space-around">
                  <Editor standard={standard} idx={idx} standardType={standard.standardType} handleChange={handleChange}/>
            </Grid>
          </CardBody>
        </Card>
      </div>
      </>
    )

}
